import UserConsentValidation from './UserConsentValidation';

export default UserConsentValidation;
